// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Xsb_","label":"SetPasswdForm_label__ZB9XY"};